import React, { useEffect } from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { useFetch } from '../../../hooks/useFetch';
import { Merchant } from '../../../domain/merchant';
import { useMerchantDetailForm } from '../hooks/useMerchantDetailForm';
import {
  Box,
  Center,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Link as ChakraLink,
  SimpleGrid,
  Spinner,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react';
import { SectionHeading } from '../../../components/SectionHeading';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import { legalTypeToString } from '../../../domain/legalType';

export const MerchantDetail = () => {
  const params = useParams();
  const { data, error, loading } = useFetch<Merchant>(`merchant-detail/${params.id}`);
  const { controls, reset } = useMerchantDetailForm();
  const columns = useBreakpointValue({ 'md': 1, 'lg': 2 });

  useEffect(() => {
    if (data) {
      reset({
        ...data,
        legal_type: legalTypeToString(data.legal_type)
      });
    }
  }, [data]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <>
      <ChakraLink as={RouterLink} to="../." color="neutral.800">
        <Flex alignItems="center">
          <MdKeyboardArrowLeft />
          <Text marginLeft="l">Volver a Comercios</Text>
        </Flex>
      </ChakraLink>

      <Center>
        <Box maxWidth="50em">
          {error && <Text marginTop="xxl" width="full" textAlign="center" color="neutral.800">Error al cargar los datos
            solicitados.</Text>}

          {!error &&
            <form>
              <SectionHeading label="Datos Generales" />

              <SimpleGrid columns={columns} spacing="xl" paddingBottom="xl" marginBottom="xl">
                <FormControl>
                  <FormLabel>ID Comercio</FormLabel>
                  <Input type="text" {...controls.identifier} disabled />
                </FormControl>
                <FormControl>
                  <FormLabel>Entidad</FormLabel>
                  <Input type="text" {...controls.legal_type} disabled />
                </FormControl>

                {/*<FormControl>*/}
                {/*  <FormLabel>Nombre de la Empresa</FormLabel>*/}
                {/*  <Input type="text" {...controls.business_name} disabled />*/}
                {/*</FormControl>*/}
                <FormControl>
                  <FormLabel>Razón social</FormLabel>
                  <Input type="text" {...controls.business_name} disabled />
                </FormControl>
                <FormControl>
                  <FormLabel>RFC</FormLabel>
                  <Input type="text" {...controls.tax_id} disabled />
                </FormControl>
                <FormControl>
                  <FormLabel>Actividad económica</FormLabel>
                  <Input type="text" {...controls.activity} disabled />
                </FormControl>
              </SimpleGrid>

              <SectionHeading label="Información representante legal"></SectionHeading>
              <SimpleGrid columns={columns} spacing="xl" paddingBottom="xl" marginBottom="xl">

                <FormControl>
                  <FormLabel>Nombre del representante</FormLabel>
                  <Input type="text" {...controls.representative_firstname} disabled />
                </FormControl>
                <FormControl>
                  <FormLabel>Apellido del representante</FormLabel>
                  <Input type="text" {...controls.representative_lastname} disabled />
                </FormControl>
                <FormControl>
                  <FormLabel>Caracter</FormLabel>
                  <Input type="text" {...controls.character} disabled />
                </FormControl> <FormControl marginRight="xl">
                <FormLabel>RFC</FormLabel>
                <Input type="text" {...controls.representative_number} disabled />
              </FormControl>
              </SimpleGrid>
            </form>
          }

        </Box>
      </Center>
    </>
  );
};
